export default __webpack_public_path__ + "static/media/clock.235ac664.svg";